import { Meta } from "@/shared/components";
import { Translations } from "@/admin/features/translations";

export function TranslationsPage() {
  return (
    <>
      <Meta title="Переводы" />
      <Translations />
    </>
  );
}
